/** @module polyfills */

/**
 * Ensure options for HTMLElement.focus() work for all browsers.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLOrForeignElement/focus
 */
export function focusOptions() {
    // use pseudo-dynamic import to make package free from side-effects
    import(/* webpackMode: "eager" */ 'focus-options-polyfill');
}
